var map = {
	"./communication/socials/socials_4.mp4": 3226,
	"./graphic/tiger/graphic_tiger.mp4": 1661,
	"./motion/app/app_1.mp4": 3210,
	"./motion/app/app_2.mp4": 8692,
	"./motion/app/app_3.mp4": 5603,
	"./motion/app/app_4.mp4": 2974,
	"./motion/telegram/motion_telegram_2.mp4": 847,
	"./product/onboarding/onboarding_4.mp4": 7616,
	"./web/birthday/birthday_2.mp4": 931,
	"./web/salary/salary_2.mp4": 1959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 413;